<template>
  <div class="home qjc-clearfix qjc-relative">
		<!-- 左侧模块 -->
		<ul class="modules qjc-fl qjc-relative">
			<li @click="to('https://medin.medinhealth.com/pc/questions/question1.html?from=dy&user=dayu')" class="medin-serve-vip">
				VIP Big Data <br> Health Body Check
			</li>
			<li @click="$router.push('/dayu/online')" class="zxwz">
				On-line Clinic
			</li>
			<li @click="$router.push('/dayu/course')" class="kcjh">
				Health Improvement Program
			</li>
			<!-- <li @click="$router.push('/dayu/shop')" class="medin-shop">
				健康商城
			</li> -->
			<li @click="to('http://yx.medinhealth.com/#/case/spc')" class="medin-case">
				Big Data Bio-report Analysis
			</li>
			
			<!-- 扫码 -->
			<li class="code qjc-absolute">
				<!-- <img class="qjc-wid-100 qjc-hei-100" src="../../../assets/images/dayu_index_code.png" alt=""> -->
				<img class="qjc-wid-100 qjc-hei-100" src="../../../assets/images/dayu_qrcode.png" alt="">
			</li>
		</ul>
		
		<!-- 右侧内容 -->
		<div class="right qjc-fr">
			<div class="top qjc-flex">
				<!-- 天气 -->
				<div class="weather qjc-flex">
					<img :src="weather.img?require('@/assets/images/' + weather.img + '.png'):''" alt="天气状况图">
					<dl>
						<dd class="qjc-fts-26">{{ weather.city }}</dd>
						<dt class="qjc-fts-36">{{ weather.temperature }}°C</dt>
						<!-- <dd class="qjc-fts-26">{{ weather.text }}</dd> -->
					</dl>
				</div>
				<!-- 日期 -->
				<dl class="date qjc-texta-r">
					<dt>{{ time }}</dt>
					<dd><span class="qjc-ftw-500">{{ date }}</span></dd>
				</dl>
			</div>
			<!-- 健康频道 -->
			<div class="health">
				<h3 class="qjc-ftw-n qjc-fts-34">
					Health Channels
					<span @click="$router.push('/dayu/health')" class="more qjc-fts-24 qjc-fr">more</span>
				</h3>
				
				<swipe @change="checkTab" :autoplay="5000" :show-indicators="false" ref="swipe">
					<swipe-item v-for="(list,index) in healthList" :key="index">
						<ul v-for="item in list" :key="item.id" class="list qjc-fts-30">
							<li @click="$router.push('/dayu/health/detail/'+ item.id)">{{ item.title }}</li>
						</ul>
					</swipe-item>
				</swipe>
				
				<ol class="tabs qjc-flex">
					<li @click="tabClick(index)" v-for="(i,index) in healthList" :key="'tab'+index" :class="{ 'active': index == healthListPage }"></li>
				</ol>
			</div>
			
		</div>
		
		<create-code language="dayu"></create-code>
		
  </div>
</template>

<script>
	// 引入vant Swipe
	import Swipe from 'vant/lib/swipe';
	import 'vant/lib/swipe/style';
	import SwipeItem from 'vant/lib/swipe-item';
	import 'vant/lib/swipe-item/style';
	//默认只能移动端事件，引入桌面端
	import '@vant/touch-emulator';
	
	import { getWeatherInfo, getHealthDy, studyList } from '@/utils/axios'
	
	import createCode from '@/components/createCode'
	
export default{
	name: 'dayuHome',
	data() {
		return {
			weather: {
				img: '',
				text: '--',
				temperature: '--',
				city: '--'
			},//天气状况
			
			date: '--',
			time: '--',
			week: '--',
			
			healthList: [],
			healthListPage: 0,
			
			
		}
	},
	components: {
		Swipe,
		SwipeItem,
		createCode
	},
	mounted() {
		this.$nextTick(() => {
			this.getWeather();
			this.getTime();
			this.getStudyList();
			// this.getHealthList();
			
			
		})
	},
	methods: {
		// 获取天气信息 参数：调用api下标
		getWeather(apiListIndex) {
			var getWeatherTime = localStorage.getItem('getWeatherTime'),
				differ = new Date().getTime() - (getWeatherTime?getWeatherTime:0);
			var res = '';
			if(differ > (30 * 60 * 1000)){
				var index = apiListIndex?apiListIndex:0;
				
				// 三条线路
				if(index < 3){
					getWeatherInfo(index).then(data => {
						console.log(data);
						res = data;
						if(res.wea_img){
							
							// 存储接口调取时间，存储数据，三十分钟后再次调取
							localStorage.setItem('getWeatherTime', new Date().getTime());
							localStorage.setItem('weatherInfo', JSON.stringify(res));
							
							this.showWeather(res);
						}else{
							this.getWeather(++index);
						}
						
					})
				}else{
					alert('天气信息获取失败');
				}
				
			}else{
				res = JSON.parse(localStorage.getItem('weatherInfo'));
				if(res.wea_img){
					this.showWeather(res);
				}else{
					localStorage.removeItem('weatherInfo');
				}
			}
			
		},
		//展示天气情况
		showWeather(res){
			// 天气状况
			this.weather.img = res.wea_img;
			this.weather.text = res.wea;// 描述
			this.weather.temperature = res.tem;// 实时气温
			this.weather.city = res.cityEn
			console.log(res)
			// 日期
			// this.date = res.date.split('-').join('/');
			// this.week = res.week;
			
			// 隔三十分钟调取一次
			var that = this;
			setTimeout(() => {
				that.getWeather();
			}, 30 * 60 * 1000);
		},
		
		// 获取健康频列表
		getHealthList(){
			getHealthDy(1, 9).then(res => {
				console.log(res);
				
				if(res.errno == 0){
					// 三条一页
					var list = this.healthList.concat(res.data.list),//只显示9条
						forList = [];
					for(var i=0;i<list.length;i++){
						var last = forList[forList.length-1];
						if(last && last.length < 3){
							last.push(list[i]);
						}else{
							forList.push([list[i]]);
						}
					}
					this.healthList = forList;
					
				}else{
					alert(res.errmsg);
				}
			});
		},
		//指示器
		checkTab(index) {
			this.healthListPage = index;
		},
		// 指示器时间
		tabClick(index) {
			this.$refs.swipe.swipeTo(index);
		},
		
		// 获取时间
		getTime() {
			var monarr = ['Jan', 'Feb', 'Mar', 'Apr ', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			// 接口无时间,获取当前时间
			var now = new Date();
			
			this.time = (now.getHours()<10?'0'+now.getHours():now.getHours()) + ':' + (now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes());
			
			// 时间校准(毫秒校准)
				var speed = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
			
			// 日期
			var weeks = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
			this.week = weeks[now.getDay()];
			this.date = this.week + ' / ' + monarr[now.getMonth()] + ' ' + now.getDate() + ', ' + now.getFullYear();
			
			// 周期性一分钟一次
			setTimeout(() => {
				this.getTime();
			}, speed);
			
		},
		
		getStudyList() {
			studyList({page: 1, pagesize: 9}).then(res => {
				if(res.code == 200) {
					var list = this.healthList.concat(res.data.data),//只显示9条
						forList = [];
					for(var i=0;i<list.length;i++){
						if(list[i].id == 1) {
							list[i].title = 'Proper Understanding of Chronic Diseases'
						}
						if(list[i].id == 2) {
							list[i].title = 'Big Data Research - Smoking'
						}
						if(list[i].id == 3) {
							list[i].title = 'Big Data Research - Blood Pressure'
						}
						if(list[i].id == 4) {
							list[i].title = 'Big Data Research - Glycemia'
						}
						if(list[i].id == 5) {
							list[i].title = 'Big Data Research - Waist Circumference'
						}
						if(list[i].id == 6) {
							list[i].title = 'Big Data Research - BMI'
						}
						if(list[i].id == 7) {
							list[i].title = 'Big Data Research - Serum Creatinine'
						}
						if(list[i].id == 8) {
							list[i].title = 'Big Data Research - Alcohol Consumption'
						}
						if(list[i].id == 9) {
							list[i].title = 'Big Data Research - Total Cholesterol'
						}
						var last = forList[forList.length-1];
						if(last && last.length < 3){
							last.push(list[i]);
						}else{
							forList.push([list[i]]);
						}
					}
					this.healthList = forList;
				}
			})
		},
		
		// 跳转链接
		to(url) {
			window.location.href = url;
		},
	}
}
</script>

<style lang="scss" scoped>
	.home{
		height: 9.9rem;
		padding: 0.6rem 0.8rem 0;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		font-weight: lighter;
		
		.modules{
			width: 11.87rem;
			
			li{
				display: flex;
				align-items: center;
				justify-content: center;
				&:not(.code){
					float: left;
					width: 5.82rem;
					height: 4.08rem;
					font-size: 0.36rem;
					color: #E3ECFF;
					background-size: 100% 100%;
					background-repeat: no-repeat;
					margin-bottom: 0.25rem;
					padding-top: 3rem;
					text-align: center;
				}
				
				&:nth-child(odd){
					margin-right: 0.23rem;
				}
				&.medin-serve-vip{
					background-image: url(../../../assets/images/medinserve_vip.png);
				}
				&.zxwz{
					background-image: url(../../../assets/images/dayu_zxwz.png);
				}
				&.kcjh{
					background-image: url(../../../assets/images/dayu_kcjh.png);
				}
				&.medin-shop{
					background-image: url(../../../assets/images/medin_shop.png);
				}
				&.medin-case{
					background-image: url(../../../assets/images/medin_case.png);
				}
				
				&:active{
					opacity: .8;
				}
				
				&.code{
					top: 50%;
					left: 50%;
					transform: translate(-50%,-50%);
					z-index: 100;
					
					img{
						width: 2.24rem;
						height: 2.24rem;
					}
				}
			}
		}
		
		.right{
			width: 5.48rem;
			color: #5FD6FF;
			
			&>div{
				background: linear-gradient(180deg,rgba(49,92,147,0.5) 0%,rgba(22,47,90,0.5) 100%);
			}
			
			.top{
				height: 1.69rem;
				justify-content: space-between;
				align-items: center;
				border-radius: 0.06rem;
				margin-bottom: 0.24rem;
				
				dt{
					font-weight: 400;
				}
				.weather{
					justify-content: flex-start;
					align-items: center;
					
					img{
						width: 1.54rem;
						height: auto;
					}
					dt{
						line-height: 0.54rem;
					}
					dd{
						line-height: 0.32rem;
					}
				}
				.date{
					padding-right: 0.24rem;
					
					dt{
						font-size: 0.72rem;
						line-height: 0.88rem;
					}
					dd{
						font-size: 0.21rem;
						line-height: 0.32rem;
					}
				}
			}
			
			.health{
				position: relative;
				width: 100%;
				height: 6.48rem;
				border-radius: 0.08rem;
				
				h3{
					line-height: 0.95rem;
					padding: 0 0.32rem;
					font-weight: lighter;
					border-bottom: 0.01rem solid #3D5E90;
					
					.more{
						position: relative;
						color: #5FD6FF;
						margin-right: 0.16rem;
						cursor: pointer;
						
						&::after{
							position: absolute;
							content: '';
							top: 50%;
							right: -0.16rem;
							width: 0.16rem;
							height: 0.16rem;
							border-top: 0.01rem solid #5FD6FF;
							border-right: 0.01rem solid #5FD6FF;
							transform: translateY(-50%)rotateZ(45deg);
						}
					}
				}
				
				.list{
					li{
						position: relative;
						font-size: 0.3rem;
						// height: 1.56rem;
						line-height: 0.5rem;
						padding: 0.28rem 0.32rem;
						overflow: hidden;
						
						&:active{
							background-color: #112948;
						}
						&::after{
							position: absolute;
							left: 0.32rem;
							right: 0.32rem;
							bottom: 0;
							content: '';
							border-bottom: 0.01rem dashed #3D5E90;
						}
					}
				}
				
				.tabs{
					position: absolute;
					bottom: 0;
					width: 100%;
					height: 0.84rem;
					justify-content: center;
					align-items: center;
					
					li{
						width: 0.16rem;
						height: 0.16rem;
						background-color: #325D6C;
						border-radius: 0.02rem;
						margin: 0 0.12rem;
						
						&.active{
							background-color: #86D2ED;
						}
					}
				}
				
			}
			
		}
		
		
	}
</style>